import { format } from 'date-fns-tz';
import queryString from 'qs';

export const getTargetRequest = (queryParams) => {
  const queries = { limit: 10, page: queryParams?.page, yearMonth: queryParams?.appliedAt ? format(queryParams?.appliedAt, 'yyyy-MM') : undefined };

  if (queryParams?.search) queries.search = queryParams.search;
  if (queryParams?.sort) queries.sort = `${queryParams?.sort?.field}.${queryParams?.sort?.order}`;
  if (queryParams?.brand) queries['brandName'] = queryParams.brand.value;

  return queryString.stringify(queries, { skipEmptyString: true });
};

export default getTargetRequest;
